<app-table-of-content-list-recursive [entryArray]="toc">
</app-table-of-content-list-recursive>
